import React  from 'react';
import { Typography } from '@mui/material'

const ProfessionalName = ({ fontSize = 18, nameProfessional }) => {
    return (
        <Typography variant="subtitle1" fontSize={fontSize} lineHeight={1.25}>
            {nameProfessional}
        </Typography>
    )
}

export default ProfessionalName
